<template lang='pug'>
  div
    v-toolbar(dense)
      v-tooltip(right)
        template(v-slot:activator='{on}')
          v-btn(v-on='on' @click='showCreateDialog = true' text icon)
            v-icon add
        span Create Account
      v-spacer
      v-spacer
      v-text-field(v-model='search' ref='search' placeholder='Search ("/" to focus)' hide-details prepend-inner-icon='search' clearable single-line)
    table-list(:headers='headers' :items='accounts' :total='total' :loading='loading' :select-all='false' :has-selection='false' @update='update')
      template(v-slot:row='{item, index}')
        td
          a(@click='assumeAccount(item._id)') {{item.name}}
        td {{item._id}}
        td {{item.email}}
        td
          v-tooltip(right)
            template(v-slot:activator='{on}')
              span(v-on='on') {{item.updatedAt | timeago}}
            span {{item.updatedAt | date}}
        td
          v-tooltip(right)
            template(v-slot:activator='{on}')
              span(v-on='on') {{item.createdAt | timeago}}
            span {{item.createdAt | date}}
        td
          v-icon(v-if='item.enabled') check
        td
          a(@click='editConcurrencyLimit(item)')
            | {{item.concurrencyLimit}}
        td
          label.file-import
            input(type='file' :ref='`import-${item._id}`' @change='importTestSuite(`import-${item._id}`, item)')
            v-icon cloud_upload
        td
          a(@click='editStripeId(item)')
            span(v-if='item.stripeCustomerId') {{item.stripeCustomerId}}
            span(v-else) Set Stripe ID
        td
          v-btn(v-if='!item.folder' text icon @click='editFolder(item)')
            v-icon add
          div(v-if='item.folder')
            a(@click='editFolder(item)')
              | {{item.folder}}
        td
          a(v-if='!item.entitlements' text icon @click='editEntitlements(item)') {}
          a(v-if='item.entitlements' @click='editEntitlements(item)') {{item.entitlements}}
        td
          v-row(justify='end').buttons
            v-tooltip(bottom)
              template(v-slot:activator='{on}')
                v-btn(v-on='on' text icon @click='assumeAccount(item._id)')
                  v-icon supervised_user_circle
              span Assume Account
            v-menu(offset-y @click.native.stop='' left).mr-3
              template(v-slot:activator='{on}')
                v-btn(text icon v-on='on')
                  v-icon more_vert
              v-list
                v-list-item(@click='disableAccount(item)')
                  v-list-item-title(v-if='item.enabled')
                    | Disable
                  v-list-item-title(v-if='!item.enabled')
                    | Enable
                v-divider
                v-list-item(@click='deleteAccount(item, index)')
                  v-list-item-title
                    | Delete
      template(v-slot:item='{item}')
        v-row(no-gutters)
          v-col(cols='12').text-body-1.pa-3
            .text-subtitle-1 {{item.name}}
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') _id:
              v-col {{item._id}}
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Email:
              v-col {{item.email}}
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Created:
              v-col
                v-tooltip(right)
                  template(v-slot:activator='{on}')
                    span(v-on='on') {{item.createdAt | date}}
                  span {{item.createdAt | timeago}}
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Updated:
              v-col
                v-tooltip(right)
                  template(v-slot:activator='{on}')
                    span(v-on='on') {{item.updatedAt | date}}
                  span {{item.updatedAt | timeago}}
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Import Suite:
              v-col
                label.file-import
                  input(type='file' :ref='`import-${item._id}-item`' @change='importTestSuite(`import-${item._id}-item`, item)')
                  a import
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Stripe Customer:
              v-col
                a(@click='editStripeId(item)')
                  span(v-if='item.stripeCustomerId') {{item.stripeCustomerId}}
                  span(v-else) Set Stripe ID
            v-row(justify='end' no-gutters)
              v-btn(text @click='assumeAccount(item._id)' color='error')
                | Assume Account
        v-divider
    v-dialog(v-model='showCreateDialog' max-width='500px')
      form(@submit.prevent='createAccount')
        v-card
          v-card-title
            span.text-h5 Create Account
          v-card-text
            v-container(grid-list-md)
              v-text-field(label='Name' v-model='newAccount.name' required autofocus)
              v-text-field(label='Email' v-model='newAccount.email' type='email' required)
          v-card-actions
            v-spacer
            v-btn(text @click.native='showCreateDialog = false') Cancel
            v-btn(text color='primary' type='submit') Create
    v-dialog(v-model='showEditFolderDialog' max-width='400px')
      v-card
        form(@submit.prevent='saveEditFolder')
          v-card-text
            v-text-field(type='text' label='Folder' v-model='account.folder' required)
          v-card-actions
            v-spacer
            v-btn(text @click.native='showEditFolderDialog=false') Cancel
            v-btn(text type='submit' color='primary') Save
    v-dialog(v-model='showEditConcurrencyLimitDialog' max-width='400px')
      v-card
        form(@submit.prevent='saveEditConcurrencyLimit')
          v-card-text
            v-text-field(type='number' label='Concurrency Limit' v-model='account.concurrencyLimit' required)
          v-card-actions
            v-spacer
            v-btn(text @click.native='showEditConcurrencyLimitDialog=false') Cancel
            v-btn(text type='submit' color='primary') Save
    v-dialog(v-model='showStripeIdDialog' max-width='400px')
      v-card
        form(@submit.prevent='saveStripeId')
          v-card-text
            v-text-field(type='text' label='Customer Stripe ID' v-model='account.stripeCustomerId' required)
          v-card-actions
            v-spacer
            v-btn(text @click.native='showStripeIdDialog=false') Cancel
            v-btn(text type='submit' color='primary') Save
    v-dialog(v-model='showEditEntitlementsDialog' max-width='800px')
      v-card
        v-card-title
          span.text-h5 Entitlements
        form(@submit.prevent='saveEntitlements')
          v-card-text
            bionic-metrics-monaco-simple-editor.inline-editor(
              ref='editor'
              type='entitlement'
              git-name='entitlements.json'
              v-model='entitlements'
              mode='json')
          v-card-actions
            v-spacer
            v-btn(text @click.native='showEditEntitlementsDialog=false') Cancel
            v-btn(text type='submit' color='primary' :loading='savingEntitlements') Save
</template>

<script>
import _ from 'lodash';
import Vue from 'vue';
import {mapActions} from 'vuex';
import SuperAdmin from '../../../api/superAdmin';
import Notifications from '../../../services/notification.service';
import TableList from '../../../components/TableList';
import TableMixin from '../../../mixins/table.mixin';
import BionicMetricsMonacoSimpleEditor from '../../../components/MonacoSimpleEditor';
import FocusMixin from '../../../mixins/focus.mixin';

export default {
  name: 'SuperAdminAccounts',
  components: {BionicMetricsMonacoSimpleEditor, TableList},
  mixins: [TableMixin, FocusMixin],
  methods: {
    async update(options) {
      this.limit = options.itemsPerPage;
      this.skip = options.itemsPerPage * (options.page - 1);
      this.sort = this.getSortFromOptions(options);
      return this.load();
    },
    async load() {
      this.loading = true;
      const {list, total} = (await SuperAdmin.getAccounts({
        skip: this.skip,
        limit: this.limit,
        sort: this.sort,
        search: this.search
      }));
      this.accounts = list;
      this.total = total;
      this.loading = false;
    },
    to(route) {
      this.$router.push(route);
    },
    async assumeAccount(id) {
      const user = await SuperAdmin.assumeAccount(id);
      await this.userAssumeAccount(user);
      this.to('/');
    },
    async createAccount() {
      try {
        const newAccount = await SuperAdmin.createAccount(this.newAccount);
        Notifications.toast('Account Created');
        this.assumeAccount(newAccount._id);
      } catch (error) {
        console.error(error);
        Notifications.alert(`Unable To create Account: ${JSON.stringify(error)}`);
      }
    },
    async disableAccount(account) {
      if (account.enabled && !(await Notifications.confirm('Disable', `Are you sure you want to disable <strong>${account.name}</strong>?`))) return;
      const enabled = !account.enabled;
      account.enabled = (await SuperAdmin.editAccount(account._id, {enabled})).enabled;
      Notifications.toast(`<strong>${account.name}</strong> ${account.enabled ? 'Enabled' : 'Disabled'}`);
    },
    async deleteAccount(account, index) {
      if (account.enabled && !(await Notifications.confirm('Delete', `Are you sure you want to delete <strong>${account.name}</strong>?`))) return;
      await SuperAdmin.deleteAccount(account._id);
      this.accounts.splice(index, 1);
      Notifications.toast(`<strong>${account.name}</strong> deleted`);
    },
    async editFolder(account) {
      this.account = account;
      this.showEditFolderDialog = true;
    },
    async editConcurrencyLimit(account) {
      this.account = account;
      this.showEditConcurrencyLimitDialog = true;
    },
    async editStripeId(account) {
      this.account = account;
      if (!this.account.stripeCustomerId) Vue.set(this.account, 'stripeCustomerId', null);
      this.showStripeIdDialog = true;
    },
    async editEntitlements(account) {
      this.account = account;
      if (!this.account.entitlements) this.entitlements = '{}';
      else this.entitlements = JSON.stringify(this.account.entitlements, false, 4);

      // Only set the editor if its been created yet (due to lazy load)
      if (this.$refs.editor) this.$refs.editor.set(this.entitlements);

      this.showEditEntitlementsDialog = true;
    },
    async saveEditFolder() {
      console.log(`Saving... ${this.account}`);
      this.account = await SuperAdmin.editAccount(this.account._id, {folder: this.account.folder});
      const acct = _.find(this.accounts, (a) => a._id === this.account._id);
      acct.folder = this.account.folder;
      Notifications.toast(`<strong>${this.account.name}</strong> folder updated to '${this.account.folder}'`);
      this.showEditFolderDialog = false;
    },
    async saveEditConcurrencyLimit() {
      console.log(`Saving... ${this.account}`);
      this.account = await SuperAdmin.editAccount(this.account._id, {concurrencyLimit: this.account.concurrencyLimit});
      const acct = _.find(this.accounts, (a) => a._id === this.account._id);
      acct.concurrencyLimit = this.account.concurrencyLimit;
      Notifications.toast(`<strong>${this.account.name}</strong> concurrency limit updated to '${this.account.concurrencyLimit}'`);
      this.showEditConcurrencyLimitDialog = false;
    },
    async saveStripeId() {
      console.log(`Saving... ${this.account}`);
      this.account = await SuperAdmin.editAccount(this.account._id, {stripeCustomerId: this.account.stripeCustomerId});
      const acct = _.find(this.accounts, (a) => a._id === this.account._id);
      acct.stripeCustomerId = this.account.stripeCustomerId;
      Notifications.toast(`<strong>${this.account.name}</strong> Stripe ID updated to '${this.account.stripeCustomerId}'`);
      this.showStripeIdDialog = false;
    },
    async saveEntitlements() {
      console.log(`Saving... ${this.entitlements}`);
      let entitlements = null;
      try {
        entitlements = JSON.parse(this.entitlements);
      } catch (error) {
        return Notifications.alert('Invalid JSON');
      }
      this.savingEntitlements = true;
      this.account = await SuperAdmin.editAccount(this.account._id, {entitlements});
      const acct = _.find(this.accounts, (a) => a._id === this.account._id);
      acct.entitlements = entitlements;
      Notifications.toast(`<strong>${this.account.name}</strong> entitlements updated to ${JSON.stringify(entitlements)}'`);
      this.savingEntitlements = false;
      this.showEditEntitlementsDialog = false;
    },
    async getTextFromFile(file) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.readAsText(file);
      });
    },
    async importTestSuite(ref, account) {
      const file = _.head(this.$refs[ref].files);
      const text = await this.getTextFromFile(file);
      const testSuite = JSON.parse(text);
      await SuperAdmin.upsertTestSuite(account._id, testSuite);
      Notifications.toast(`Successfully upserted ${testSuite.name} to ${account.name}`);
    },
    ...mapActions({userAssumeAccount: 'userAssumeAccount'})
  },
  watch: {
    // eslint-disable-next-line
    search: _.debounce(function () {
      this.load();
    }, 250)
  },
  data() {
    return {
      newAccount: {},
      accounts: [],
      account: {},
      search: '',
      total: 0,
      loading: false,
      showCreateDialog: false,
      showEditFolderDialog: false,
      showEditConcurrencyLimitDialog: false,
      showStripeIdDialog: false,
      showEditEntitlementsDialog: false,
      savingEntitlements: false,
      entitlements: null,
      skip: 0,
      limit: 10,
      sort: {name: 1},
      defaultSort: {name: 1},
      headers: [
        {text: 'Name', value: 'name'},
        {text: 'id', value: '_id'},
        {text: 'Email', value: 'email'},
        {text: 'Updated', value: 'updatedAt'},
        {text: 'Created', value: 'createdAt'},
        {text: 'Enabled', value: 'enabled'},
        {text: 'Concurrency Limit', value: 'concurrencyLimit'},
        {text: 'Import', value: 'import', sortable: false},
        {text: 'Stripe Customer', value: 'stripeCustomerId'},
        {text: 'Git Folder', value: 'folder'},
        {text: 'Entitlements', value: 'entitlements', sortable: false},
        {text: '', value: 'actions', sortable: false}
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
  .file-import {
    input[type='file'] {
      display: none;
    }
  }

  .inline-editor {
    width: 100%;
    min-height: 30vh;
  }

  .buttons {
    width: 120px;
  }
</style>
